import { downloader } from "../helpers/downloader";

export function downloadFiles(
  docs: Array<string>,
  type: string,
  token: string | null,
) {
  const url = (type) => {
    switch (type) {
      case "ite":
        return `/storage/ite/documents/download?token=${token}`;
      case "pub":
        return "/storage/pub/documents/download";
      default:
        return "/storage/documents/download";
    }
  };

  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: STORAGE_REQUEST });
    return fetch(`${url(type)}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ docs }),
    })
      .then(async (resp) => {
        if (resp.ok) {
          const data = await resp.arrayBuffer();
          dispatch({ type: STORAGE_SUCCESS, payload: data });
          downloader(data);
        } else {
          const err = await resp.text();
          dispatch({ type: STORAGE_FAILURE, payload: err });
        }
      })
      .catch((err) => {
        dispatch({ type: STORAGE_FAILURE, payload: err });
      });
  };
}

export const STORAGE_REQUEST = "Storage.Request";
export const STORAGE_SUCCESS = "Storage.Success";
export const STORAGE_FAILURE = "Storage.Failure";
export const STORAGE_RESET = "Storage.Reset";
